export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 10
            },
            {
                heading : "Learn CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive Web design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Advanced',
                lessionNumber : 5
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "JavaScript Basics",
                description : " Learn the fundamentals of JavaScript programming, including variables, data types, functions, control structures, and DOM manipulation.",
                level : 'Beginner',
                lessionNumber : 9
            },
            {
                heading : "Python for Beginners",
                description : "Dive into the world of Python programming, covering syntax, data structures, control flow, functions, and file handling.",
                level : 'Beginner',
                lessionNumber : 33
            },
            {
                heading : "Introduction to SQL ",
                description : "Learn the fundamentals of SQL, including database structures, how to write SQL queries, and how to navigate the PostgreSQL database server.",
                level : 'Beginner',
                lessionNumber : 11
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Mobile App Development",
                description : "Explore the fundamentals of mobile app development, covering UI design, navigation, data storage, and deployment for iOS and Android platforms.",
                level : 'Advanced',
                lessionNumber : 13
            },
            {
                heading : "Web Development with React",
                description : "Learn the fundamentals of React, including JSX, the Virtual DOM, props, state, event handling, and working with data and APIs.",
                level : 'Advanced',
                lessionNumber : 15
            },
            {
                heading : "Cybersecurity Essentials",
                description : "Learn the fundamentals of cybersecurity, including how to detect threats, protect systems and networks, and anticipate potential cyber attacks.",
                level : 'Beginner',
                lessionNumber : 9
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "Discover the fundamentals of web development with Flask, a Python-based microframework. Learn to build dynamic web applications, handle routes, manage templates, and interact with databases.",
                level : 'Advanced',
                lessionNumber : 5
            },
            {
                heading : "Django",
                description : "Learn the fundamentals of web development with Django 2 by building a portfolio website with HTML, CSS, Python, and Django.",
                level : 'Advanced',
                lessionNumber : 17
            },
            {
                heading : "Fast API",
                description : "Learn the fundamentals of FastAPI, a Python-based framework for building web applications quickly and efficiently using modern software design principles.",
                level : 'Advanced',
                lessionNumber : 10
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "Learn the fundamentals of Next.js, a React framework for building server-side rendered and statically generated React applications.",
                level : 'Advanced',
                lessionNumber : 15
            },
            {
                heading : "Graphic Design Principles",
                description : "Learn the fundamentals of graphic design, including typography, imagery, composition, layout, and color theory in a hands-on approach using Photoshop.",
                level : 'Advanced',
                lessionNumber : 12
            },
            {
                heading : "Sanity",
                description : "Learn the fundamentals of Sanity, a headless CMS for structured content that can be delivered through any channel.",
                level : 'Advanced',
                lessionNumber : 8
            },
        ]
    },
]